import { Injectable } from '@angular/core';
import { TransformService } from './transform.service';
import { ArrayService } from './array.service';
import { DatetimeService } from './datetime.service';
import { StringExtensionsService } from './stringExtensions.service';

@Injectable({
  providedIn: 'root',
})
export class SharedFunctionsService {
  constructor(
    private transformService: TransformService,
    private arrayService: ArrayService,
    private datetimeService: DatetimeService,
    private stringExtensionService: StringExtensionsService
  ) {}

  /**
   * Returns a list of distinct elements from the given input array based on the specified key selector function.
   *
   * @template T - The type of elements in the input array.
   * @param {T[]} items - The input array of items.
   * @param {(item: T) => any} keySelector - A function that selects the key to determine distinctness.
   * @returns {any[]} - An array of distinct elements based on the selected key.
   */
  getDistinctIds<T>(items: T[], keySelector: (item: T) => any): any[] {
    return [...new Set(items.map(keySelector))];
  }

  compareIds(title1: any, title2: any): boolean {
    return title1 && title2 ? title1.id === title2.id : title1 === title2;
  }

  //#region Transfrom functions
  transformItems = this.transformService.transformItems;
  transformUserName = this.transformService.transformUserName;
  //#endregion

  //#region Array fucntions
  isNullOrEmpty = this.arrayService.isNullOrEmpty;
  //#endregion

  //#region dateTime functions
  dateToyyyyMMddHHmmss = this.datetimeService.dateToyyyyMMddHHmmss;
  dateToyyyyMMdd = this.datetimeService.dateToyyyyMMdd;
  //#region Manipulation functions
  capitalize = this.stringExtensionService.capitalize;
  //#endregion
}
